import React from 'react';
import clsx from 'clsx';
import { Radio } from '../../..';
import styles from './SelectDuration.module.scss';
import { splitPriceByThree } from '../../../../utils';

const SelectDuration = ({
  title,
  price,
  unit,
  description,
  selectedDuration,
  value,
  onRadioChange,
  disable,
}) => {
  const renderRadioSelection = () => {
    if (disable) return title;

    return (
      <Radio
        value={value}
        checkedValue={selectedDuration}
        label={title}
        onChecked={onRadioChange}
      />
    );
  };

  return (
    <label
      className={clsx(
        styles.selectDuration,
        value === selectedDuration && styles.isActive,
        disable && styles.disable
      )}
    >
      <div>
        {renderRadioSelection()}
        {description && (
          <span className={styles.description}>{description}</span>
        )}
      </div>
      <div>
        <span className={styles.price}>{splitPriceByThree(price)}</span>
        <span className={styles.unit}>{unit}</span>
      </div>
    </label>
  );
};

export default SelectDuration;
